import { Box, RadioList } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { shopSortOptions } from '../../content/shop.content';
import { ShopSortProps } from './ShopSort.types';

function ShopSort({ sortParam, onSort }: ShopSortProps) {
  return (
    <Box paddingTop="space-600">
      <RadioList options={shopSortOptions} value={sortParam} onValue={onSort} />
    </Box>
  );
}

export default memo(ShopSort);
